
import { defineComponent } from 'vue'

import Home from './Home.vue'
import VueDoc from './docs/Vue.vue'

export default defineComponent({
    name: 'App',
    components: { VueDoc, Home }
});
